import classNames from "classnames";
import { useTranslations } from "next-intl";
import { useMemo } from "react";

import styles from "./review-time-ago.module.scss";

type Props = {
  timestamp: number;
  display?: "absolute" | "none";
};

export default function ReviewTimeAgo(props: Props) {
  const t = useTranslations();
  const { timestamp, display } = props;

  const timeAgo = useMemo(() => {
    const date = new Date(timestamp);
    const now = new Date();
    let years = now.getFullYear() - date.getFullYear();
    let months = now.getMonth() - date.getMonth() + years * 12;
    if (now.getDate() < date.getDate()) {
      months--;
    }
    if (months >= 12) {
      years = Math.floor(months / 12);
      return years === 1 ? t("reviews.oneYearAgo") : t("reviews.yearsAgo", { years: years });
    }
    if (months > 0) {
      return months === 1 ? t("reviews.oneMonthAgo") : t("reviews.monthsAgo", { months: months });
    }
    const days = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
    return days <= 0 ? t("reviews.today") : days === 1 ? t("reviews.oneDayAgo") : t("reviews.daysAgo", { days: days });
  }, [timestamp, t]);

  return <div className={classNames(styles.reviewsDate, styles[display || ""])}>{timeAgo}</div>;
}
